
/* eslint-disable */
import { queryMerchantInfo, bindCard, threeDs2AuthInit, threeDs2AuthPayer, authorizePay } from "@/api/pay.js"
import { getFetchUrl, fetchScript, runScript, getJsFromScript } from "./bind-card.js"
import { Checkbox } from "element-ui"

export default {
  API: ["onSubmit", "init"],
  props: {
    showSaveCheck: {
      type: Boolean,
      default: true
    }
  },
  components: {
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      pageStatus: "init", // init beforeVerify verifying done
      errors: {},
      loading: false,
      thisYear: new Date().getFullYear().toString().slice(2, 4),
      monthOptions: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      tradeNo: "",
      signNum: "", // 当前生成额签约号
      cardNumber: "",
      bank: "",
      isSaveCardNo: true
    }
  },
  computed: {
    expiryYearOptions() {
      const thisYear = parseInt(this.thisYear)
      return [...new Array(20)].map((item, index) => {
        return thisYear + index
      })
    }
  },
  methods: {
    init() {
      // this.tradeNo = '';
      // this.pageStatus = 'init';
      // this.loading = false;
      // this.errors = {};
    },
    onSubmit() {
      switch (this.pageStatus) {
        case "init":
          this.loading = true
          PaymentSession.updateSessionFromForm("card")
          break
        case "beforeVerify":
          this.loading = true
          this.authInit(this.tradeNo)
          break
        default:
          break
      }
    },
    async authInit(tradeNo) {
      try {
        const { data: res } = await threeDs2AuthInit({
          params: JSON.stringify({
            tradeNo
          })
        })
        if (res.proceedStatus == "1" || res.proceedStatus == "12") {
          // 3ds验证
          document.getElementById("threeds-container").innerHTML = res.url
          const { subJs, id } = getJsFromScript()
          runScript(subJs)
          if (id === "initiate-authentication-script") {
            setTimeout(() => {
              this.authPayer(tradeNo)
            }, 1500)
          } else if (id === "authenticate-payer-script") {
            this.loading = false
            this.pageStatus = "verifying"
            this.$emit("status-changed", {
              status: "verifying"
            })
          }
        } else if (res.proceedStatus == "2") {
          // 预授权
          this.authorizePay(tradeNo)
        } else {
          this.$message.error(res.message || this.$t("checkout.errorTips"))
          this.$emit("status-changed", {
            status: "error"
          })
        }
      } catch (error) {
        console.log(error)
        this.$emit("status-changed", {
          status: "error"
        })
      }
    },
    async authPayer(tradeNo) {
      try {
        const { data: res } = await threeDs2AuthPayer({
          params: JSON.stringify({
            tradeNo
          })
        })
        if (res.proceedStatus == "1" || res.proceedStatus == "12") {
          // 3ds验证
          document.getElementById("threeds-container").innerHTML = res.url
          const { subJs } = getJsFromScript()
          runScript(subJs)
          this.pageStatus = "verifying"
          this.$emit("status-changed", {
            status: "verifying"
          })
        } else if (res.proceedStatus == "2") {
          // 预授权
          this.authorizePay(tradeNo)
        } else {
          this.$message.error(res.message || this.$t("checkout.errorTips"))
          this.$emit("status-changed", {
            status: "error"
          })
          return
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async authorizePay(tradeNo) {
      this.loading = true
      try {
        const { data: res } = await authorizePay({
          params: JSON.stringify({
            tradeNo,
            isSaveCardNo: this.isSaveCardNo ? 1 : 0
          })
        })
        this.pageStatus = "done"
        if (res.paymentStatus == "2") {
          this.$emit("status-changed", {
            status: "done",
            payload: {
              signNum: this.signNum
            }
          })
          this.$message({
            message: this.$t("checkout.bindCardSuccess"),
            type: "success"
          })
          this.$emit("trackAddPaymentInfo")
        } else {
          this.$emit("status-changed", {
            status: "error"
          })
        }
      } catch (error) {
        console.log(error)
        this.$emit("status-changed", {
          status: "error"
        })
      } finally {
        this.loading = false
      }
    },
    async bindCard(sessionId) {
      try {
        const { data: res } = await bindCard({
          params: JSON.stringify({
            payWay: 801,
            sessionId
          })
        })
        this.tradeNo = res.tradeNo
        this.signNum = res.signNum
        this.pageStatus = "beforeVerify"
        this.$emit("status-changed", {
          status: "beforeVerify"
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    initConfig() {
      this.loading = true
      // if (self === top) {
      //   var antiClickjack = document.getElementById("antiClickjack");
      //   antiClickjack.parentNode && antiClickjack.parentNode.removeChild(antiClickjack);
      // } else {
      //   top.location = self.location;
      // }
      // 初始化PaymentSession配置
      PaymentSession.configure({
        fields: {
          // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
          card: {
            number: "#card-number",
            securityCode: "#security-code",
            expiryMonth: "#expiry-month",
            expiryYear: "#expiry-year",
            nameOnCard: "#cardholder-name"
          }
        },
        //SPECIFY YOUR MITIGATION OPTION HERE
        frameEmbeddingMitigation: ["javascript"],
        callbacks: {
          initialized: response => {
            this.loading = false
          },
          formSessionUpdate: response => {
            // HANDLE RESPONSE FOR UPDATE SESSION
            this.loading = false
            if (response.status) {
              if ("ok" == response.status) {
                this.errors = {}
                const { scheme, number } = response.sourceOfFunds.provided.card
                this.bank = scheme
                this.cardNumber = number
                if (!response.sourceOfFunds.provided.card.securityCode) {
                  this.errors.securityCode = "missing"
                  return
                }
                // nameOnCard
                this.bindCard(response.session.id)
              } else if ("fields_in_error" == response.status) {
                this.errors = response.errors
                // this.$message.error('请求错误');
              } else if ("request_timeout" == response.status) {
                this.$message({
                  message: `Session update failed with request timeout: ${response.errors.message}`,
                  type: "warning"
                })
              } else if ("system_error" == response.status) {
                this.$message.error(this.$t("checkout.systemError"))
              }
            } else {
            }
          }
        },
        interaction: {
          displayControl: {
            formatCard: "EMBOSSED",
            invalidFieldCharacters: "REJECT"
          }
        }
      })
    },
    submitCallback(e) {
      if (!e.origin.includes("gateway.mastercard")) return
      if (JSON.parse(e.data).result === "SUCCESS") {
        console.log("111", JSON.parse(e.data))
        this.authorizePay(this.tradeNo)
      }
    }
  },
  destroyed() {
    window.removeEventListener("message", this.submitCallback)
  },
  mounted() {
    window.addEventListener("message", this.submitCallback)
    // const scriptUrl = await getFetchUrl();
    // await fetchScript(scriptUrl);
    try {
      if (PaymentSession) {
        this.initConfig()
      }
    } catch (error) {
      this.$message({
        message: "Load Session failed",
        type: "warning"
      })
    }
  }
}
